<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Matriz from "@/components/widgets/network-matriz";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Matriz,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      id: this.$route.params.id || '',
      positions: [],
      levels: [],

      loading: false,
      matriz: null,
    };
  },
  methods: {
    getMatriz() {
      this.loading = true;
      this.matriz = null;

      api.get("network/test/matriz/" + this.id).then((response) => {
        if (response.data.status == "success") {
          this.positions = response.data.positions;
          this.levels = response.data.levels;
          this.matriz = response.data.matriz;

          if (this.matriz[0] && this.matriz[0].id) {
            this.id = this.matriz[0].id;
          } else {
            this.id = '';
          }
        } else {
          this.matriz = null;
        }

        this.loading = false;
      });
    },
  },
  mounted() {
    this.getMatriz();
  },
  watch: {
    id: function (v) {
      this.$router.push("/network/test/matriz/" + v);
      this.getMatriz();
    }
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Matriz 2x15 Fases</h3>
        <p></p>
      </div>
      <div>
        <select v-model="id" class="custom-select mb-1">
          <option v-for="(row,index) in positions" :value="row.id" :key="index">{{ row.name }}&nbsp;&nbsp;</option>
        </select>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <Matriz :data="matriz"></Matriz>
        <template v-if="loading">
          <div class="text-center p-3">
            <b-spinner class="ml-2 align-middle" variant="default" role="status"></b-spinner>
          </div>
        </template>
        <template v-else-if="matriz && matriz.length == 0">
          <div class="text-center p-3">
            Nenhuma posição ativa neste ciclo.
          </div>
        </template>
      </div>
    </div>

    <fieldset>
      <legend>Níveis</legend>
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
          <tr>
            <th class="text-center">Nível</th>
            <th class="text-center">Qtd Atual</th>
            <th class="text-center">Qtd Máxima</th>
            <th class="text-center">Falta Completar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in levels" :key="row.level">
            <td class="text-center">{{ row.level }}º</td>
            <td class="text-center">{{ row.current | points }}</td>
            <td class="text-center">{{ row.total | points }}</td>
            <td class="text-center">{{ row.missing | points }}</td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </Layout>
</template>
